import React from 'react';
import { Skeleton } from 'gatorcomponents';
import * as Styles from './Header.styles';

export const HeaderSkeleton = () => (
  <Styles.Header>
    <Styles.HeaderBrand>
      <Skeleton variant="rectangle" width="117px" height="40px" borderRadius="4px" />
      <Styles.HeaderTitleWrapper>
        <Skeleton variant="rectangle" width="180px" height="20px" />
        <Skeleton variant="rectangle" width="140px" height="16px" />
      </Styles.HeaderTitleWrapper>
    </Styles.HeaderBrand>

    <Styles.InputsWrapper>
      <Styles.AccountDropdownWrapper>
        <Skeleton variant="rounded" width="225px" height="56px" borderRadius="8px" />
      </Styles.AccountDropdownWrapper>

      <Styles.DateInputsWrapper>
        <Skeleton variant="rounded" width="140px" height="56px" borderRadius="8px" />
        <Styles.DateInputsSeparator />
        <Skeleton variant="rounded" width="140px" height="56px" borderRadius="8px" />
      </Styles.DateInputsWrapper>
    </Styles.InputsWrapper>
  </Styles.Header>
);
